import React, { useEffect, useRef } from "react";
import "./LedgerFilter.scss";
import { useFormik } from "formik";
import * as Yup from "yup";
import LedgerFilterDates from "./LedgerFilterDates";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { commonAction } from "../../../redux/features/commonSlice";
import CloseIcon from "../../../components/icons/CloseIcon";

interface LedgerFilterProps {
  currentFilters: any;
  onApply: (values: any) => void;
  onClear: () => void;
}

const LedgerFilter = ({
  currentFilters,
  onApply,
  onClear,
}: LedgerFilterProps) => {
  const dispatch = useDispatch();

  const filterBox = useSelector(
    (state: RootState) => state?.common?.homePageFilter,
  );

  const filterRef = useRef<HTMLDivElement>(null);

  const onCloseFilter = () => {
    dispatch(commonAction.setHomePageFilter());
  };

  const formik = useFormik({
    initialValues: {
      start_date: currentFilters.start_date || "",
      end_date: currentFilters.end_date || "",
    },

    enableReinitialize: true,

    validationSchema: Yup.object({
      start_date: Yup.string().optional(),
      end_date: Yup.string().optional(),
    }),

    onSubmit: (values) => {
      onApply(values);
      onCloseFilter();
    },
  });

  const onClickClear = () => {
    formik.resetForm();
    onClear();
    onCloseFilter();
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        filterRef.current &&
        !filterRef.current.contains(event.target as Node)
      ) {
        document.dispatchEvent(new Event("closeAllDropdowns"));
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <form onSubmit={formik.handleSubmit}>
      <div
        className={`properties-filter-container ${
          filterBox ? "" : "deactivate-filter"
        }`}
      >
        <div className="filter-background" onClick={onCloseFilter}></div>

        <div className="properties-filter-box" ref={filterRef}>
          <div className="filter-top-heading">
            <p className="filter-top-head">Filters</p>

            <div className="filter-close-icon" onClick={onCloseFilter}>
              <CloseIcon />
            </div>
          </div>

          <div className="filter-body-container">
            <LedgerFilterDates formik={formik} lable="Transaction Date" />
          </div>

          <div className="action-btn-filter">
            <button
              className="clear-filters-btn"
              type="button"
              onClick={onClickClear}
            >
              Clear Filters
            </button>

            <button className="apply-btn" type="submit">
              Apply
            </button>
          </div>
        </div>
      </div>
    </form>
  );
};

export default LedgerFilter;
